var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 330.001 330.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "skip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_238_",
    d: "M315.001,0.001c-8.284,0-15,6.716-15,15v113.788L175.607,4.394c-4.29-4.29-10.743-5.574-16.347-3.252 c-5.605,2.322-9.26,7.792-9.26,13.858v113.788L25.607,4.394C21.317,0.104,14.864-1.18,9.26,1.142 c-5.605,2.322-9.26,7.792-9.26,13.858v300c0,6.067,3.654,11.537,9.26,13.858c1.855,0.769,3.805,1.143,5.736,1.143 c3.904,0,7.741-1.524,10.61-4.394l124.394-124.392v113.786c0,6.067,3.654,11.537,9.26,13.858c1.855,0.769,3.805,1.143,5.736,1.143 c3.904,0,7.741-1.524,10.61-4.394l124.394-124.392v113.786c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15v-300 C330.001,6.716,323.285,0.001,315.001,0.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.fc7b0f37cce795bbbc26e398d0ea5105.svg";
export { ForwardRef as ReactComponent };